<template>
  <div id="admin-user">
    <!-- 帳號管理 -->
    <div
      id="auser"
      class="tab-pane fade show"
      role="tabpanel"
      aria-labelledby="aau"
    >
      <div class="col-12 pt-3 table-style">
        <!-- 功能欄 -->
        <v-query-layout>
          <!-- 1 -->
          <v-label
            slot="ql1-text-1"
            for="query-keyword"
            LabText="篩選資料："
            Labbold="true"
          />
          <input
            id="query-keyword"
            class="input-style"
            type="text"
            slot="ql1-input-1"
            placeholder="請輸入關鍵字"
            v-model="filter"
          >
          <v-label
            v-if="Backend"
            slot="ql1-text-2"
            class="ml-2"
            for="query-dept"
            LabText="查詢單位："
            Labbold="true"
          />
          <v-Dept
            v-if="Backend"
            id="query-dept"
            slot="ql1-input-2"
            style="width: 290px;"
            :DeptData="NewDeptId"
            @SelectDept="SelectDept"
          />
          <!-- 2 -->
          <v-label
            slot="ql2-text-1"
            for="query-user"
            LabText="查詢帳號："
            Labbold="true"
          />
          <input
            id="query-user"
            class="input-style"
            type="text"
            slot="ql2-input-1"
            placeholder="請輸入要查詢的帳號"
            v-model="QueryUserId"
          >
          <div slot="ql2-input-2">
            <v-button
              btn-text="查詢"
              btn-outline="primary"
              @click.native="InquireFeeitemQuery"
            >
              <font-awesome-icon
                slot="icon"
                icon="search"
              />
            </v-button>
            <v-button
              class="ml-2"
              btn-text="清除"
              btn-outline="secondary"
              @click.native="ClearCondition"
            >
              <font-awesome-icon
                slot="icon"
                icon="search-minus"
              />
            </v-button>
          </div>
          <!-- 3 -->
          <v-label
            slot="ql3-text-1"
            for="query-page"
            LabText="筆數："
            Labbold="true"
          />
          <v-page
            slot="ql3-input-1"
            id="query-page"
            @RecPerPage="RecPerPage"
          />
        </v-query-layout>
        <hr>
        <!-- 表格資料 -->
        <template>
          <b-table
            hover
            small
            bordered
            responsive
            show-empty
            empty-text="查無資料。"
            :items="items"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :current-page="currentPage"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <!-- 姓名(套特殊字型) -->
            <template v-slot:cell(UserName)="data">
              <span class="nukWord">
                {{ data.item.UserName }}
              </span>
            </template>
            <template v-slot:cell(NeedReceipt)="data">
              <span v-if="data.item.NeedReceipt === 0">
                {{ '否' }}
              </span>
              <span v-else>
                {{ '是' }}
              </span>
            </template>
            <!-- 帳號狀態 -->
            <template v-slot:cell(AccountStatus)="data">
              <div
                v-for="Type in AccountType"
                :key="Type.id"
                :value="Type.value"
              >
                <div v-if="data.item.AccountStatus == Type.value">
                  {{ Type.text }}
                </div>
              </div>
            </template>
            <!-- 權限狀態 -->
            <template v-slot:cell(BackendPrivilege)="data" >
              <div
                v-for="BType in BackendType"
                :key="BType.id"
                :value="BType.value"
              >
                <div v-if="data.item.BackendPrivilege == BType.value">
                  {{ BType.text }}
                </div>
              </div>
            </template>
            <!-- 功能 -->
            <template
              v-slot:cell(feature)="data"
              v-if="Backend === true"
            >
              <!-- 條件: 1.已認證 -->
              <v-button
                v-if="data.item.AccountStatus === 1"
                title="停用帳號"
                btn-text="停用"
                btn-size="sm"
                btn-type="secondary"
                @click.native="CheckPrivilegeDisable(data.item)"
              />
              <!-- 條件: 1.已認證 2.申請管理or業務-->
              <v-button
                v-if="data.item.AccountStatus === 1 && data.item.BackendPrivilege === 1 || data.item.BackendPrivilege === 2"
                class="ml-2"
                title="帳號權限開通"
                btn-text="開通"
                btn-size="sm"
                btn-type="primary"
                @click.native="CheckPrivilegeEnable(data.item)"
              />
            </template>
          </b-table>
          <!-- 分頁 -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          />
        </template>
        <br>
      </div>
    </div>
    <!-- 後台-停用帳號 -->
    <v-modal id="disable">
      <div slot="header">
        停用帳號
      </div>
      <div slot="body">
        確認是否停用「{{ disableData.UserName }}」帳號?
      </div>
      <div slot="footer">
        <v-button
          btn-text="確認停用"
          btn-type="danger"
          @click.native="PostPrivilegeDisable"
        />
        <v-button
          class="ml-1"
          btn-text="取消"
          btn-type="secondary"
          data-dismiss="modal"
          aria-label="Close"
        />
      </div>
    </v-modal>
    <!-- 後台-權限開通 -->
    <v-modal id="enable">
      <div slot="header">
        開通帳號權限
      </div>
      <div slot="body">
        確認是否開通「{{ enableData.UserName }}」帳號權限?
      </div>
      <div slot="footer">
        <v-button
          btn-text="確認開通"
          btn-type="primary"
          @click.native="PostPrivilegeEnable"
        />
        <v-button
          class="ml-1"
          btn-text="取消"
          btn-type="secondary"
          data-dismiss="modal"
          aria-label="Close"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import md5 from 'js-md5'
import $ from 'jquery'
import vLabel from '@/components/Features/Label'
import vModal from '@/components/Features/ModalFloot'
import vQueryLayout from '@/components/Layout/QueryLayout'
import { apiPrivilegeQuery, apiPrivilegeDisable, apiPrivilegeEnable } from '../../Api/api'
export default {
  components: {
    vModal,
    vLabel,
    vQueryLayout
  },
  data () {
    return {
      items: [],
      fields: [
        { key: 'SerialNo', label: '#', thClass: 'table-th', variant: 'info' },
        { key: 'UserId', label: '帳號', thClass: 'table-th' },
        { key: 'UserName', label: '(繳款人)姓名', thClass: 'table-th' },
        { key: 'Email', label: '信箱', thClass: 'table-th' },
        { key: 'Telephone', label: '電話', thClass: 'table-th' },
        { key: 'NeedReceipt', label: '需要收據(是/否)', thClass: 'table-th' },
        { key: 'DeptDesc', label: '單位', thClass: 'table-th', sortable: true },
        { key: 'AccountStatus', label: '帳號狀態', thClass: 'table-th', sortable: true, variant: 'warning' },
        { key: 'BackendPrivilege', label: '權限狀態', thClass: 'table-th', sortable: true, variant: 'danger' },
        { key: 'feature', label: '功能', thClass: 'table-th' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      disableData: {},
      enableData: {},
      AccountType: [
        { text: '已停用', value: '0' },
        { text: '已認證', value: '1' },
        { text: '申請註冊中', value: '255' }
      ],
      BackendType: [
        { text: '申請未通過', value: '0' },
        { text: '申請管理者權限中', value: '1' },
        { text: '申請業務單位權限中', value: '2' },
        { text: '管理者權限', value: '11' },
        { text: '業務單位權限', value: '12' },
        { text: '一般使用者', value: '255' }
      ],
      ApplyDeptId: '',
      AllDeptData: [],
      NewDeptId: sessionStorage.getItem('UserDeptID') ? JSON.parse(sessionStorage.getItem('UserDeptID')) : '',
      QueryUserId: '',
      Backend: false,
      errfunction: 0
    }
  },
  computed: {
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created () { // 從Dept組件接收部門資料
    this.$bus.$on('AllDept', (data) => {
      this.AllDepts(data)
    })
  },
  mounted () {
    this.user()
    this.PostPrivilegeQuery()
    this.CheckQueryDept()
  },
  methods: {
    user () { // 帳號權限判斷
      const Data = sessionStorage.getItem('Backend')
      const admin = md5('業務')
      if (Data === admin) {
        this.Backend = false
      } else {
        this.Backend = true
      }
    },
    PostPrivilegeQuery () { // 查詢 B_API 003
      // 定義資料
      var vm = this
      var NewData
      var UserNewData = []
      // API預設資料
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      // 查詢條件
      const UserQuery = JSON.parse(sessionStorage.getItem('UserQuery'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      if (!UserQuery) { // No QueryData
        if (!vm.Backend) {
          IdentityData.DeptId = UserData.DeptId
          IdentityData.QueryUserId = ''
          NewData = IdentityData
        } else {
          IdentityData.DeptId = ''
          IdentityData.QueryUserId = ''
          NewData = IdentityData
        }
      } else {
        vm.ApplyDeptId = UserQuery.DeptId
        vm.QueryUserId = UserQuery.QueryUserId
        NewData = Object.assign(IdentityData, UserQuery)
      }
      // 呼叫API
      apiPrivilegeQuery(NewData).then(
        res => {
          // 過濾一般使用者，DeptId:''
          if (res !== undefined) {
            for (let i = 0; i < res.Data.length; i++) {
              if (res.Data[i].DeptId !== '') {
                const json = res.Data[i]
                json.SerialNo = i + 1
                UserNewData[i] = json
              }
            }
            vm.items = UserNewData
            vm.totalRows = vm.items.length
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    CheckQueryDept () { // 未查詢選擇部門時
      if (this.ApplyDeptId === '') {
        this.NewDeptId = ''
      }
    },
    AllDepts (data) { // 從Dept組件取得部門資料
      if (this.errfunction === 0) {
        this.AllDeptData = data
        this.errfunction = 1
      }
    },
    SelectDept (vDeptId) { // 組件-部門
      this.NewDeptId = vDeptId
      sessionStorage.setItem('UserDeptID', JSON.stringify(vDeptId))
    },
    RecPerPage (SublayerPage) { // 組件筆數
      this.perPage = SublayerPage
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    InquireFeeitemQuery () { // 查詢條件
      // 定義資料
      var vm = this
      var UserNewData = []
      var Serial = 1
      var l = 0
      // 查詢條件
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      const QueryData = {}
      // 判斷有無選擇部門單位>只有admin呈現部門下拉選單
      if (!vm.Backend) { // 業務帳號
        NewData.DeptId = UserData.DeptId
        NewData.QueryUserId = vm.QueryUserId
        QueryData.DeptId = UserData.DeptId
      } else { // 管理admin
        if (vm.NewDeptId) {
          vm.ApplyDeptId = vm.NewDeptId.DeptId
        }
        NewData.DeptId = vm.ApplyDeptId
        NewData.QueryUserId = vm.QueryUserId
        QueryData.DeptId = vm.ApplyDeptId
      }
      // 紀錄查詢條件
      QueryData.QueryUserId = vm.QueryUserId
      sessionStorage.setItem('UserQuery', JSON.stringify(QueryData))
      // 呼叫API
      apiPrivilegeQuery(NewData).then(
        res => {
          if (res !== undefined) {
            for (let i = 0; i < res.Data.length; i++) {
              if (res.Data[i].DeptId !== '') {
                res.Data[i].SerialNo = Serial++
                UserNewData[l] = res.Data[i]
                l++
              }
            }
            vm.items = UserNewData
            vm.totalRows = UserNewData.length
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    ClearCondition () { // 清除查詢條件
      sessionStorage.removeItem('UserQuery')
      sessionStorage.removeItem('UserDeptID')
      this.ApplyDeptId = ''
      this.NewDeptId = ''
      this.QueryUserId = ''
      this.PostPrivilegeQuery()
    },
    CheckPrivilegeDisable (data) { // 呼叫停用帳號Modal
      this.disableData = data
      $('#disable').modal('show')
    },
    PostPrivilegeDisable () { // 停用 B_API 006
      $('#disable').modal('hide')
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.DisableUserId = vm.disableData.UserId
      NewData.DisableDeptId = vm.disableData.DeptId
      // 呼叫API
      apiPrivilegeDisable(NewData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('Modals', '帳號已停用')
            $('#CheckOk').modal('show')
            vm.PostPrivilegeQuery()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    CheckPrivilegeEnable (data) { // 呼叫權限開通Modal
      this.enableData = data
      $('#enable').modal('show')
    },
    PostPrivilegeEnable () { // 開通 B_API 005
      $('#enable').modal('hide')
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.EnableUserId = vm.enableData.UserId
      NewData.EnableDeptId = vm.enableData.DeptId
      // 呼叫API
      apiPrivilegeEnable(NewData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('Modals', '帳號已開通')
            $('#CheckOk').modal('show')
            vm.PostPrivilegeQuery()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    }
  }
}
</script>
